import { ReactElement, useMemo, useCallback } from 'react';
import { useSnackbar } from 'notistack';

import { useLazyRequest } from '~hooks/index';
import { deleteItemPreset } from '~services/item';
import { ItemPreset, ItemPresetParse } from '~services/item/types';
import { camelCaseSerializer } from '~utils/serializer';
import { DialogConfimation } from '~components/index';

import { OrdersFiltersPresetsV2DialogConfirmDeleteProps } from './types';

const OrdersFiltersPresetsV2DialogConfirmDelete = ({
  open,
  onClose,
  selectedPreset,
  onSuccess,
}: OrdersFiltersPresetsV2DialogConfirmDeleteProps): ReactElement => {
  const { enqueueSnackbar } = useSnackbar();

  const messageConfirmation = useMemo(
    () => `El filtro ${selectedPreset.description} será eliminado`,
    [selectedPreset.description],
  );

  const [, loadingDeletePreset, , executeDeletePreset] = useLazyRequest({
    request: deleteItemPreset,
    withPostSuccess: (response) => {
      const presetResponse = response.data?.data as ItemPreset;
      const parsePresetResponse: ItemPresetParse = {
        ...presetResponse,
        data: camelCaseSerializer.serialize(JSON.parse(presetResponse.data)),
      };
      const message = `El filtro ${parsePresetResponse.description} fue eliminado correctamente`;

      onSuccess(parsePresetResponse);

      enqueueSnackbar(message, { variant: 'success' });
    },
    withPostFailure: () => {
      enqueueSnackbar('No se pudo eliminar el filtro, intente nuevamente', {
        variant: 'error',
      });
    },
  });

  const handleDeletePreset = useCallback(() => {
    executeDeletePreset(selectedPreset.presetId);
  }, [executeDeletePreset, selectedPreset.presetId]);

  return (
    <DialogConfimation
      open={open}
      description={messageConfirmation}
      onConfirm={handleDeletePreset}
      onCancel={onClose}
      loadingConfirm={loadingDeletePreset}
    />
  );
};

export default OrdersFiltersPresetsV2DialogConfirmDelete;
